import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Button } from 'App/components'
import { EModalComponents } from 'App/containers'
import { showModalAction } from 'store'
import { ReactComponent as PlusIcon } from 'assets/icons/Plus.svg'

export type TUserProfileEducationButtonProps = {
  disabled?: boolean
}

export const UserProfileEducationButton = (props: TUserProfileEducationButtonProps) => {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { disabled, ...modalProps } = props

  const handleClick = () => {
    dispatch(
      showModalAction({
        modalProps,
        modalTitle: t('modal.userEducation.title_add'),
        modalType: EModalComponents.EDUCATION_DIALOG
      })
    )
  }

  return (
    <Button icon={<PlusIcon />} variant="text" disabled={disabled} onClick={handleClick}>
      {t('userProfile.education.addEducationButton')}
    </Button>
  )
}
